export type AnalyticsLocale = "it" | "en" | "fr" | "es" | "de";
// Shared by the CRM and immutable printable reports.
const labels = {
  chartMetric: ["Metrica del grafico", "Chart metric", "Mesure du graphique", "Métrica del gráfico", "Diagrammkennzahl"],
  chartNote: ["Sono mostrati gli intervalli con eventi raccolti. Gli intervalli senza dati non vengono ricostruiti. Tabelle dettagliate disponibili sotto; i visitatori di siti diversi non sono persone deduplicate.", "Only intervals with collected events are shown. Missing intervals are not reconstructed. Detailed tables below; cross-site visitors are not deduplicated people.", "Seuls les intervalles avec événements collectés sont affichés. Les intervalles manquants ne sont pas reconstruits. Tableaux détaillés ci-dessous ; visiteurs non dédupliqués entre sites.", "Solo se muestran intervalos con eventos recogidos. No se reconstruyen intervalos sin datos. Tablas detalladas debajo; visitantes no deduplicados entre sitios.", "Nur Intervalle mit erfassten Ereignissen werden gezeigt. Fehlende Intervalle werden nicht rekonstruiert. Tabellen unten; Besucher sind nicht websiteübergreifend dedupliziert."],
  siteComparison: ["Confronto fra siti", "Website comparison", "Comparaison des sites", "Comparación de sitios", "Websitevergleich"],
  quickPeriod: ["Periodo rapido", "Quick period", "Période rapide", "Período rápido", "Schnellzeitraum"],
  today: ["Oggi", "Today", "Aujourd’hui", "Hoy", "Heute"],
  days: ["giorni", "days", "jours", "días", "Tage"],
  nativeSource: ["Fonte: raccolta autonoma Enkey · nessuna dipendenza da GA4", "Source: independent Enkey collection · no GA4 dependency", "Source : collecte autonome Enkey · indépendante de GA4", "Fuente: recogida autónoma Enkey · independiente de GA4", "Quelle: eigene Enkey-Erfassung · unabhängig von GA4"],
  engagementCoverage: [
    "Sessioni con tempo attivo misurabile",
    "Sessions with measurable active time",
    "Sessions avec temps actif mesurable",
    "Sesiones con tiempo activo medible",
    "Sitzungen mit messbarer aktiver Zeit",
  ],
  medianReturnDays: [
    "Giorni mediani fra ritorni osservati",
    "Median days between observed returns",
    "Jours médians entre retours observés",
    "Mediana de días entre retornos observados",
    "Median der Tage zwischen beobachteter Wiederkehr",
  ],
  accountConsent: [
    "Collega le mie visite al mio account",
    "Link my visits to my account",
    "Associer mes visites à mon compte",
    "Vincular mis visitas a mi cuenta",
    "Meine Besuche mit meinem Konto verknüpfen",
  ],
  accountConsentDescription: [
    "Facoltativo. Se accedo, autorizzo Enkey ad associare al mio account le pagine pubbliche visitate, la frequenza e i percorsi, per 90 giorni. Posso revocare qui. Richiede Statistiche; non collega visite precedenti né altri siti automaticamente.",
    "Optional. When signed in, I allow Enkey to link public pages visited, frequency and journeys to my account for 90 days. I can withdraw here. Requires Statistics; no earlier visits or automatic cross-site linking.",
    "Facultatif. Une fois connecté, j’autorise Enkey à associer à mon compte les pages publiques visitées, la fréquence et les parcours pendant 90 jours. Révocable ici. Nécessite Statistiques ; sans visites antérieures ni lien automatique entre sites.",
    "Opcional. Al iniciar sesión, autorizo a Enkey a asociar a mi cuenta páginas públicas visitadas, frecuencia y recorridos durante 90 días. Revocable aquí. Requiere Estadísticas; sin visitas anteriores ni vinculación automática entre sitios.",
    "Optional. Angemeldet erlaube ich Enkey, besuchte öffentliche Seiten, Häufigkeit und Wege 90 Tage lang meinem Konto zuzuordnen. Hier widerrufbar. Erfordert Statistiken; keine früheren Besuche oder automatische websiteübergreifende Verknüpfung.",
  ],
  title: [
    "Statistiche e Report",
    "Statistics and Reports",
    "Statistiques et rapports",
    "Estadísticas e informes",
    "Statistiken und Berichte",
  ],
  subtitle: [
    "Il pubblico del network, con fonti e limiti visibili.",
    "Your network audience, with visible sources and limitations.",
    "L’audience du réseau, avec sources et limites visibles.",
    "La audiencia de la red, con fuentes y límites visibles.",
    "Das Publikum des Netzwerks, mit sichtbaren Quellen und Grenzen.",
  ],
  overview: [
    "Panoramica",
    "Overview",
    "Vue d’ensemble",
    "Resumen",
    "Übersicht",
  ],
  audience: [
    "Pubblico e ritorni",
    "Audience and returns",
    "Audience et retours",
    "Audiencia y retornos",
    "Publikum und Wiederkehr",
  ],
  content: [
    "Contenuti e percorsi",
    "Content and journeys",
    "Contenus et parcours",
    "Contenido y recorridos",
    "Inhalte und Wege",
  ],
  advertising: [
    "Banner e obiettivi",
    "Banners and goals",
    "Bannières et objectifs",
    "Banners y objetivos",
    "Banner und Ziele",
  ],
  sources: [
    "Google e autorevolezza",
    "Google and authority",
    "Google et autorité",
    "Google y autoridad",
    "Google und Autorität",
  ],
  identities: [
    "Account riconosciuti",
    "Recognized accounts",
    "Comptes reconnus",
    "Cuentas reconocidas",
    "Erkannte Konten",
  ],
  reports: ["Report", "Reports", "Rapports", "Informes", "Berichte"],
  settings: [
    "Siti e qualità",
    "Sites and quality",
    "Sites et qualité",
    "Sitios y calidad",
    "Websites und Qualität",
  ],
  views: [
    "Pagine viste",
    "Page views",
    "Pages vues",
    "Páginas vistas",
    "Seitenaufrufe",
  ],
  sessions: [
    "Sessioni osservate",
    "Observed sessions",
    "Sessions observées",
    "Sesiones observadas",
    "Beobachtete Sitzungen",
  ],
  visitors: [
    "Visitatori unici per sito",
    "Unique visitors per site",
    "Visiteurs uniques par site",
    "Visitantes únicos por sitio",
    "Eindeutige Besucher je Website",
  ],
  knownBefore: [
    "Già conosciuti prima del periodo",
    "Known before this period",
    "Déjà connus avant la période",
    "Conocidos antes del período",
    "Vor dem Zeitraum bekannt",
  ],
  newlyObserved: [
    "Osservati per la prima volta",
    "First observed visitors",
    "Visiteurs observés pour la première fois",
    "Observados por primera vez",
    "Erstmals beobachtet",
  ],
  returningVisitors: [
    "Unici con una visita di ritorno",
    "Unique visitors with a return visit",
    "Visiteurs uniques avec une visite de retour",
    "Únicos con una visita de retorno",
    "Eindeutige Besucher mit Wiederkehr",
  ],
  repeatInPeriod: [
    "Unici con più sessioni nel periodo",
    "Unique visitors with multiple sessions",
    "Visiteurs uniques avec plusieurs sessions",
    "Únicos con varias sesiones",
    "Eindeutige Besucher mit mehreren Sitzungen",
  ],
  returningRate: [
    "Quota visitatori di ritorno",
    "Returning visitor share",
    "Part des visiteurs de retour",
    "Proporción de visitantes recurrentes",
    "Anteil wiederkehrender Besucher",
  ],
  sessionsPerVisitor: [
    "Sessioni per visitatore",
    "Sessions per visitor",
    "Sessions par visiteur",
    "Sesiones por visitante",
    "Sitzungen je Besucher",
  ],
  viewsPerSession: [
    "Pagine per sessione",
    "Pages per session",
    "Pages par session",
    "Páginas por sesión",
    "Seiten je Sitzung",
  ],
  activeSecondsPerSession: [
    "Secondi attivi per sessione",
    "Active seconds per session",
    "Secondes actives par session",
    "Segundos activos por sesión",
    "Aktive Sekunden je Sitzung",
  ],
  bounceRate: [
    "Sessioni senza coinvolgimento",
    "Sessions without engagement",
    "Sessions sans engagement",
    "Sesiones sin interacción",
    "Sitzungen ohne Interaktion",
  ],
  conversionRate: [
    "Sessioni con obiettivo / sessioni",
    "Sessions with a goal / sessions",
    "Sessions avec objectif / sessions",
    "Sesiones con objetivo / sesiones",
    "Sitzungen mit Ziel / Sitzungen",
  ],
  conversions: [
    "Eventi obiettivo",
    "Goal events",
    "Événements objectif",
    "Eventos de objetivo",
    "Zielereignisse",
  ],
  live: [
    "Attivi negli ultimi 5 minuti",
    "Active in the last 5 minutes",
    "Actifs ces 5 dernières minutes",
    "Activos en los últimos 5 minutos",
    "Aktiv in den letzten 5 Minuten",
  ],
  liveNote: [
    "Presenza osservata, non numero certo di persone online.",
    "Observed presence, not an exact count of people online.",
    "Présence observée, pas un décompte exact des personnes en ligne.",
    "Presencia observada, no un recuento exacto de personas en línea.",
    "Beobachtete Anwesenheit, keine exakte Anzahl von Personen online.",
  ],
  frequency: [
    "Frequenza: sessioni per unico nel periodo",
    "Frequency: sessions per unique visitor",
    "Fréquence : sessions par visiteur unique",
    "Frecuencia: sesiones por visitante único",
    "Häufigkeit: Sitzungen je eindeutigem Besucher",
  ],
  historyNote: [
    "Nuovi e già conosciuti sono gruppi distinti. Chi torna può essere nuovo nel periodo. Il riconoscimento dipende da consenso, browser e storico conservato (90 giorni). Gli unici di più siti sono sommati, non deduplicati come persone.",
    "New and previously known are distinct groups. Returning visitors may be new in this period. Recognition depends on consent, browser and retained history (90 days). Cross-site uniques are summed, not deduplicated people.",
    "Nouveaux et déjà connus sont distincts. Un visiteur de retour peut être nouveau sur la période. Identification selon consentement, navigateur et historique conservé (90 jours). Les uniques multisites sont additionnés, sans déduplication des personnes.",
    "Nuevos y conocidos son grupos distintos. Quien retorna puede ser nuevo en el período. El reconocimiento depende del consentimiento, navegador e historial conservado (90 días). Los únicos de varios sitios se suman, sin deduplicar personas.",
    "Neue und bereits bekannte Besucher sind getrennte Gruppen. Wiederkehrende können im Zeitraum neu sein. Erkennung hängt von Einwilligung, Browser und gespeichertem Verlauf (90 Tage) ab. Websiteübergreifende Werte werden addiert, nicht als Personen dedupliziert.",
  ],
  coverageNote: [
    "Misure first-party Enkey delle visite consentite. Blocchi, revoche, bot non rilevati e cookie rimossi possono influire. Nessun dato non equivale a zero visite. Tempo attivo e percorsi riguardano soltanto la finestra selezionata.",
    "Enkey first-party measurements of consented visits. Blocking, withdrawal, undetected bots and removed cookies may affect results. No data does not mean zero visits. Active time and journeys cover only the selected window.",
    "Mesures Enkey des visites consenties. Blocages, retraits, robots non détectés et cookies supprimés peuvent influer. Absence de données ne signifie pas zéro visite. Temps actif et parcours limités à la fenêtre choisie.",
    "Medidas Enkey de visitas consentidas. Bloqueos, revocaciones, bots no detectados y cookies eliminadas pueden influir. Sin datos no significa cero visitas. Tiempo activo y recorridos limitados al intervalo elegido.",
    "Enkey-Messungen eingewilligter Besuche. Blockaden, Widerruf, unerkannte Bots und gelöschte Cookies können Ergebnisse beeinflussen. Keine Daten bedeutet nicht null Besuche. Aktive Zeit und Wege gelten nur für das gewählte Fenster.",
  ],
  empty: [
    "Nessun dato disponibile per questa selezione",
    "No data available for this selection",
    "Aucune donnée disponible pour cette sélection",
    "No hay datos para esta selección",
    "Keine Daten für diese Auswahl",
  ],
  setup: [
    "Modulo predisposto: raccolta disattivata o database da configurare.",
    "Module prepared: collection disabled or database not configured.",
    "Module préparé : collecte désactivée ou base à configurer.",
    "Módulo preparado: recopilación desactivada o base sin configurar.",
    "Modul vorbereitet: Erfassung deaktiviert oder Datenbank noch einzurichten.",
  ],
  partial: [
    "Copertura parziale: controllare data di attivazione e retention",
    "Partial coverage: check activation date and retention",
    "Couverture partielle : vérifier activation et conservation",
    "Cobertura parcial: revise activación y retención",
    "Teilabdeckung: Aktivierungsdatum und Aufbewahrung prüfen",
  ],
  refresh: ["Aggiorna", "Refresh", "Actualiser", "Actualizar", "Aktualisieren"],
  pause: [
    "Pausa aggiornamento live",
    "Pause live updates",
    "Suspendre le direct",
    "Pausar actualización en vivo",
    "Live-Aktualisierung pausieren",
  ],
  resume: [
    "Attiva aggiornamento live",
    "Enable live updates",
    "Activer le direct",
    "Activar actualización en vivo",
    "Live-Aktualisierung aktivieren",
  ],
  from: [
    "Dal (incluso)",
    "From (inclusive)",
    "Du (inclus)",
    "Desde (incluido)",
    "Von (einschließlich)",
  ],
  to: [
    "Al (escluso)",
    "To (exclusive)",
    "Au (exclu)",
    "Hasta (excluido)",
    "Bis (ausschließlich)",
  ],
  timezone: [
    "Fuso dei raggruppamenti",
    "Grouping timezone",
    "Fuseau des regroupements",
    "Zona horaria de agrupación",
    "Zeitzone der Gruppierung",
  ],
  hour: ["Ora", "Hour", "Heure", "Hora", "Stunde"],
  day: ["Giorno", "Day", "Jour", "Día", "Tag"],
  month: ["Mese", "Month", "Mois", "Mes", "Monat"],
  year: ["Anno", "Year", "Année", "Año", "Jahr"],
  compare: [
    "Confronto periodo precedente",
    "Previous period comparison",
    "Comparaison période précédente",
    "Comparación con período anterior",
    "Vergleich mit vorherigem Zeitraum",
  ],
  trend: ["Andamento", "Trend", "Évolution", "Evolución", "Entwicklung"],
  sites: [
    "Confronto siti",
    "Site comparison",
    "Comparaison des sites",
    "Comparación de sitios",
    "Websitevergleich",
  ],
  pages: ["Pagine", "Pages", "Pages", "Páginas", "Seiten"],
  countries: [
    "Paese stimato (non nazionalità)",
    "Estimated country (not nationality)",
    "Pays estimé (pas nationalité)",
    "País estimado (no nacionalidad)",
    "Geschätztes Land (keine Nationalität)",
  ],
  devices: ["Dispositivi", "Devices", "Appareils", "Dispositivos", "Geräte"],
  browsers: ["Browser", "Browsers", "Navigateurs", "Navegadores", "Browser"],
  operatingSystems: [
    "Sistemi operativi",
    "Operating systems",
    "Systèmes d’exploitation",
    "Sistemas operativos",
    "Betriebssysteme",
  ],
  languages: ["Lingue", "Languages", "Langues", "Idiomas", "Sprachen"],
  referrers: [
    "Siti di provenienza",
    "Referring sites",
    "Sites référents",
    "Sitios de procedencia",
    "Verweisende Websites",
  ],
  campaigns: ["Campagne", "Campaigns", "Campagnes", "Campañas", "Kampagnen"],
  paths: [
    "Passaggi osservati fra pagine",
    "Observed page transitions",
    "Transitions observées entre pages",
    "Transiciones observadas entre páginas",
    "Beobachtete Seitenwechsel",
  ],
  entries: [
    "Prime pagine osservate",
    "First observed pages",
    "Premières pages observées",
    "Primeras páginas observadas",
    "Zuerst beobachtete Seiten",
  ],
  lastPages: [
    "Ultime pagine osservate (uscita non certa)",
    "Last observed pages (exit not certain)",
    "Dernières pages observées (sortie incertaine)",
    "Últimas páginas observadas (salida no confirmada)",
    "Zuletzt beobachtete Seiten (Ausstieg ungewiss)",
  ],
  scroll: [
    "Profondità di scorrimento",
    "Scroll depth",
    "Profondeur de défilement",
    "Profundidad de desplazamiento",
    "Scrolltiefe",
  ],
  impressions: [
    "Impression erogate",
    "Served impressions",
    "Impressions diffusées",
    "Impresiones servidas",
    "Ausgelieferte Impressionen",
  ],
  visible: [
    "Impression visibili",
    "Viewable impressions",
    "Impressions visibles",
    "Impresiones visibles",
    "Sichtbare Impressionen",
  ],
  clicks: ["Clic", "Clicks", "Clics", "Clics", "Klicks"],
  bannerNote: [
    "Visibilità: almeno 50% per 1 secondo continuo. CTR = clic / impression erogate. Misurazione Enkey non certificata.",
    "Viewability: at least 50% for 1 continuous second. CTR = clicks / served impressions. Uncertified Enkey measurement.",
    "Visibilité : au moins 50 % pendant 1 seconde continue. CTR = clics / impressions diffusées. Mesure Enkey non certifiée.",
    "Visibilidad: al menos 50% durante 1 segundo continuo. CTR = clics / impresiones servidas. Medición Enkey no certificada.",
    "Sichtbarkeit: mindestens 50 % für 1 Sekunde ohne Unterbrechung. CTR = Klicks / ausgelieferte Impressionen. Nicht zertifizierte Enkey-Messung.",
  ],
  notConnected: [
    "Non collegato",
    "Not connected",
    "Non connecté",
    "Sin conectar",
    "Nicht verbunden",
  ],
  sync: [
    "Acquisisci dati Google",
    "Fetch Google data",
    "Récupérer les données Google",
    "Obtener datos de Google",
    "Google-Daten abrufen",
  ],
  providerNote: [
    "Fonti distinte: non sommare GA4 ed Enkey. Keyword aggregate, aggiornamenti differiti; DA/PA solo da fonte Moz documentata. I valori non disponibili restano assenti.",
    "Separate sources: do not add GA4 and Enkey. Aggregated keywords and delayed updates; DA/PA only from documented Moz sources. Unavailable values remain missing.",
    "Sources distinctes : ne pas additionner GA4 et Enkey. Requêtes agrégées et mises à jour différées ; DA/PA uniquement depuis Moz documenté. Valeurs indisponibles laissées absentes.",
    "Fuentes distintas: no sume GA4 y Enkey. Consultas agregadas y actualizaciones diferidas; DA/PA solo de Moz documentado. Los valores no disponibles quedan ausentes.",
    "Getrennte Quellen: GA4 und Enkey nicht addieren. Aggregierte Suchanfragen und verzögerte Aktualisierungen; DA/PA nur aus dokumentierter Moz-Quelle. Fehlende Werte bleiben fehlend.",
  ],
  createReport: [
    "Archivia report Enkey Agency",
    "Archive Enkey Agency report",
    "Archiver le rapport Enkey Agency",
    "Archivar informe Enkey Agency",
    "Enkey-Agency-Bericht archivieren",
  ],
  print: [
    "Apri / stampa / salva PDF",
    "Open / print / save PDF",
    "Ouvrir / imprimer / enregistrer PDF",
    "Abrir / imprimir / guardar PDF",
    "Öffnen / drucken / PDF speichern",
  ],
  csv: [
    "Esporta CSV",
    "Export CSV",
    "Exporter CSV",
    "Exportar CSV",
    "CSV exportieren",
  ],
  reportNote: [
    "Snapshot aggregato immutabile. Segmenti con meno di 5 visitatori omessi. Nessun invio automatico, dato nominativo o firma digitale simulata.",
    "Immutable aggregated snapshot. Segments with fewer than 5 visitors omitted. No automatic sending, named data or simulated digital signature.",
    "Instantané agrégé immuable. Segments de moins de 5 visiteurs omis. Aucun envoi automatique, donnée nominative ou signature simulée.",
    "Instantánea agregada inmutable. Se omiten segmentos con menos de 5 visitantes. Sin envío automático, datos nominales ni firma digital simulada.",
    "Unveränderlicher aggregierter Stand. Segmente mit weniger als 5 Besuchern ausgelassen. Kein automatischer Versand, keine Namensdaten oder simulierte digitale Signatur.",
  ],
  generated: ["Generato", "Generated", "Généré", "Generado", "Erstellt"],
  source: ["Fonte", "Source", "Source", "Fuente", "Quelle"],
  count: ["Conteggio", "Count", "Nombre", "Recuento", "Anzahl"],
  activeMs: [
    "Tempo attivo (ms)",
    "Active time (ms)",
    "Temps actif (ms)",
    "Tiempo activo (ms)",
    "Aktive Zeit (ms)",
  ],
  save: [
    "Salva sito",
    "Save site",
    "Enregistrer le site",
    "Guardar sitio",
    "Website speichern",
  ],
  enabled: [
    "Raccolta abilitata",
    "Collection enabled",
    "Collecte activée",
    "Recopilación activada",
    "Erfassung aktiviert",
  ],
  name: ["Nome", "Name", "Nom", "Nombre", "Name"],
  origin: [
    "Origine HTTPS canonica verificata",
    "Verified canonical HTTPS origin",
    "Origine HTTPS canonique vérifiée",
    "Origen HTTPS canónico verificado",
    "Verifizierter kanonischer HTTPS-Ursprung",
  ],
  company: [
    "ID azienda CRM",
    "CRM company ID",
    "ID entreprise CRM",
    "ID empresa CRM",
    "CRM-Unternehmens-ID",
  ],
  project: [
    "ID progetto CRM (facoltativo)",
    "CRM project ID (optional)",
    "ID projet CRM (facultatif)",
    "ID proyecto CRM (opcional)",
    "CRM-Projekt-ID (optional)",
  ],
  identityEnabled: [
    "Associazione account con consenso specifico",
    "Account linking with specific consent",
    "Lien du compte avec consentement spécifique",
    "Vinculación de cuenta con consentimiento específico",
    "Kontoverknüpfung mit gesonderter Einwilligung",
  ],
  status: ["Stato", "Status", "État", "Estado", "Status"],
  lastEvent: [
    "Ultimo evento",
    "Last event",
    "Dernier événement",
    "Último evento",
    "Letztes Ereignis",
  ],
  error: [
    "Operazione non riuscita",
    "Operation failed",
    "Échec de l’opération",
    "La operación falló",
    "Vorgang fehlgeschlagen",
  ],
  methodology: [
    "Metodo e limiti",
    "Method and limitations",
    "Méthode et limites",
    "Método y límites",
    "Methode und Grenzen",
  ],
  unknown: [
    "Non disponibile / sconosciuto",
    "Unavailable / unknown",
    "Indisponible / inconnu",
    "No disponible / desconocido",
    "Nicht verfügbar / unbekannt",
  ],
  showMore: [
    "Mostra tutte le righe",
    "Show all rows",
    "Afficher toutes les lignes",
    "Mostrar todas las filas",
    "Alle Zeilen anzeigen",
  ],
  loading: [
    "Caricamento…",
    "Loading…",
    "Chargement…",
    "Cargando…",
    "Wird geladen…",
  ],
  identityNote: [
    "Solo account autenticati, con consenso specifico sul sito. Nessuna ricostruzione delle visite precedenti. Consultazione registrata nell’audit.",
    "Only authenticated accounts with specific site consent. No reconstruction of earlier visits. Access is audited.",
    "Comptes authentifiés avec consentement spécifique au site uniquement. Aucun historique antérieur reconstruit. Consultation auditée.",
    "Solo cuentas autenticadas con consentimiento específico del sitio. Sin reconstrucción de visitas anteriores. Consulta auditada.",
    "Nur angemeldete Konten mit gesonderter Website-Einwilligung. Keine Rekonstruktion früherer Besuche. Zugriff wird protokolliert.",
  ],
} as const;
export type AnalyticsLabel = keyof typeof labels;
export function analyticsText(locale: string) {
  const index = Math.max(
    0,
    ["it", "en", "fr", "es", "de"].indexOf(locale.split("-")[0]),
  );
  return (key: AnalyticsLabel) => labels[key][index];
}
